export default __webpack_public_path__ + "static/1_30-89bbc98042158b4bca6c6a7d9a3efe1d.png";